import moment, { Moment } from "moment";
import { ClasseAtivo, Mercado, Negociacao, TipoOperacao } from "./enum";

export default class PosicaoAtivo implements IPosicaoAtivo {
  public codigoAtivo!: string;
  public mercado!: Mercado;
  public precoMedio!: number;
  public quantidade!: number;
  public tipoNegociacao!: Negociacao;
  public tipoOperacao!: TipoOperacao;
  public valorTotal!: number;
  public classeAtivo!: ClasseAtivo;
  public prazo?: Moment;
  constructor(param: IPosicaoAtivo) {
    Object.assign(this, param);
  }

  toJSON(): IPosicaoAtivoJson {
    return { ...this, prazo: this.prazo?.format() };
  }

  static fromFirestore(obj: any): PosicaoAtivo {
    return new PosicaoAtivo({
      codigoAtivo: obj.codigoAtivo,
      mercado: obj.mercado,
      precoMedio: obj.precoMedio,
      quantidade: obj.quantidade,
      tipoNegociacao: obj.tipoNegociacao,
      tipoOperacao: obj.tipoOperacao,
      valorTotal: obj.valorTotal,
      classeAtivo: obj.classeAtivo,
      prazo: obj.prazo ? moment(obj.prazo.toDate()) : undefined,
    });
  }
}

export interface IPosicaoAtivoJson extends Omit<IPosicaoAtivo, "prazo"> {
  prazo?: string;
}

interface IPosicaoAtivo {
  codigoAtivo: string;
  mercado: Mercado;
  precoMedio: number;
  quantidade: number;
  tipoNegociacao: Negociacao;
  tipoOperacao: TipoOperacao;
  valorTotal: number;
  classeAtivo: ClasseAtivo;
  prazo?: Moment;
}
